<template>
  <sModal
    footer-hide
    :mask-closable="false"
    :value="true"
    @close="$emit('close')">
    <div
      slot="header"
      class="flex my-auto mx-4">
      <TooltipedText
        :line-count="2"
        :value="notification.title"/>
    </div>
    <div style="min-width: 300px; display: flex; align-items: center; justify-content: center; padding-bottom: 10px;">
      <div
        v-if="loading"
        style="width:100%;text-align:center;">
        <sIcon
          class="my-5 mx-auto"
          color="var(--secondary__green_not_active)"
          size="30"
          spin
          type="loading"/>
      </div>
      <sAlert
        v-else-if="error"
        class="width-100"
        :description="error"
        show-icon
        :title="$t('Common.ErrorTitle')"
        type="error"/>
      <template v-else>
        <iframe
          v-if="isIFrame"
          :src="iframeSrc || content"
          style="width:100%;height:70vh;border:none;display:block;"
          @error="onIframeError"
          @load="sendReadState()"/>
        <div
          v-else
          v-dompurify-html="content"
          :dompurify-html-config="{ ADD_TAGS: ['iframe'], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'style', 'width', 'height'] }"
          style="width: 100%; max-width: 100%; box-sizing: border-box; min-height: fit-content;"/>
      </template>
    </div>
  </sModal>
</template>
<script>
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'
import NotificationApi from '@/api/notificationApi'
const notif_api = new NotificationApi()

export default {
  name: 'ModalPreviewSmartNotification',
  components: {
    TooltipedText
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      content: '',
      loading: true,
      error: '',
    }
  },
  methods: {
    async loadContent() {
      this.loading = true
      if (!this.notification.notificationId) {
        this.error = this.$t('Common.errorLoadingData')
        this.loading = false
        return
      }
      this.error = ''
      this.content = ''
      try {
        const result = await notif_api.getNotificationContent(this.notification.notificationId)
        if (!result) {
          this.error = this.$t('Common.errorLoadingData')
        } else {
          this.content = result
        }
        if (!this.isIFrame) {
          this.sendReadState()
        }
      } catch (e) {
        this.error = this.$t('Common.errorLoadingData')
      } finally {
        this.loading = false
      }
    },
    onIframeError() {
      this.error = this.$t('Common.errorLoadingData')
      this.content = ''
    },
    sendReadState() {
      notif_api.setNotificationViewed([this.notification.notificationId])
        .then(() => {
          this.$emit('notification-read', this.notification.notificationId)
        })
        .catch(() => {})
    }
  },
  computed: {
    isPureUrl() {
      return this.content && /^https?:\/\//.test(this.content.trim()) && !/[<>]/.test(this.content)
    },
    iframeSrc() {
      const match = this.content && this.content.trim().match(/^<iframe\s+[^>]*src=["']([^"']+)["'][^>]*><\/iframe>$/i)
      return match ? match[1] : ''
    },
    isIFrame() {
      return this.iframeSrc || this.isPureUrl
    },
  },
  mounted() {
    this.loadContent()
  }
}
</script>